<template>
	<div id="usuario-listar">
		<ld-table
			:getData="getUsuarios"
			:columnDefs="columnDefs"
			loadingText="Aguarde. Estamos carregando os usuários"
			:update="atualizar"
			:clearFilters="limparFiltros"
		>
			<div
				class="flex ag-grid-table-actions-right"
				v-if="$permissions.can('autenticadosuperuser') || $permissions.can('colaboradoradicionar')"
			>
				<ld-button
					class="mt-4"
					icon="add"
					@click="popupAdicionarUsuario = true"
					>Adicionar usuário</ld-button
				>
			</div>
		</ld-table>

		<popup-adicionar-usuario
			:active.sync="popupAdicionarUsuario"
			:closed="() => {
				limparFiltrosTabela();
			}"
		/>

		<popup-editar-usuario
			:active.sync="popupEditarUsuario"
			:closed="atualizarTabela"
			:usuarioPk.sync="usuarioEditarPk"
		/>
	</div>
</template>

<script>
import { mapActions } from "vuex";

import Usuario from "../../../models/Usuario";
import avatarLeftIcon from "../../../components/ld-table/utils/avatarLeftIcon.js";
import actionButtons from "../../../components/ld-table/utils/actionButtons.js";
import PopupAdicionarUsuario from "../usuario_adicionar/UsuarioAdicionar";
import PopupEditarUsuario from "../usuario_editar/UsuarioEditar";
import DateHelper from '../../../helpers/DateHelper';

export default {
	name: "Usuarios",
	data() {
		return {
			popupAdicionarUsuario: false,
			popupEditarUsuario: false,
			usuarioEditarPk: null,
			atualizar: {
				table: false
			},
			limparFiltros: {
				table: false
			}
		};
	},
	components: {
		PopupAdicionarUsuario,
		PopupEditarUsuario
	},
	computed: {
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		columnDefs() {
			// Se o path vier com o pk da empresa, quer dizer que esta dentro de uma empresa
			// Configuracao de coluna da tabela para quando acesso for por dentro de uma empresa
			if (this.empresaPk) {
				return [
					{
						headerName: "Usuário",
						field: "nome",
						cellRenderer: avatarLeftIcon(
							"fotoThumb",
							null,
							"icon-user"
						),
						style: {
							"min-width": "150px"
						}
					},
					{
						headerName: "Perfil",
						field: "perfil",
						cellRenderer: params => {
							try {
								const perfil = params.value;
								return perfil.nome;
							} catch (error) {
								console.error(error);
								return "";
							}
						},
						style: {
							"min-width": "150px"
						}
					},
					{
						headerName: "Status",
						field: "bloqueado",
						filter: "select",
						filterSelectData: [
							{ text: "Todos", value: "" },
							{ text: "Bloqueado", value: true },
							{ text: "Desbloqueado", value: false }
						],
						style: {
							"min-width": "150px",
							"max-width": "123px"
						}
					},
					{
						headerName: "",
						field: "acaoButtons",
						filterColumnDisabled: true,
						cellRenderer: actionButtons([
							{
								name: "Ver",
								onclick: this.verUsuario
							}
						]),
						filter: false,
						style: {
							width: "70px",
							"max-width": "200px",
							"min-width": "131px"
						}
					}
				];
			}

			// Configuracao de coluna da tabela para quando acesso for por fora de uma empresa
			return [
				{
					headerName: "Usuário",
					field: "nome",
					cellRenderer: avatarLeftIcon(
						"fotoThumb",
						null,
						"icon-user"
					),
					style: {
						"min-width": "150px"
					}
				},
				{
					headerName: "Empresa",
					field: "empresa",
					cellRenderer: params => {
						try {
							const empresa = params.value;
							return empresa.nome;
						} catch (error) {
							console.error(error);
							return "";
						}
					},
					style: {
						"min-width": "150px"
					}
				},
				{
					headerName: "Perfil",
					field: "perfil",
					cellRenderer: params => {
						try {
							const perfil = params.value;
							return perfil.nome;
						} catch (error) {
							console.error(error);
							return "";
						}
					},
					style: {
						"min-width": "150px"
					}
				},
				{
					headerName: "Status",
					field: "bloqueado",
					filter: "select",
					filterSelectData: [
						{ text: "Todos", value: "" },
						{ text: "Bloqueado", value: true },
						{ text: "Desbloqueado", value: false }
					],
					style: {
						"min-width": "150px",
						"max-width": "123px"
					}
				},
				{
					headerName: "",
					field: "acaoButtons",
					filterColumnDisabled: true,
					cellRenderer: actionButtons([
						{
							name: "Ver",
							onclick: this.verUsuario
						}
					]),
					filter: false,
					style: {
						width: "70px",
						"max-width": "200px",
						"min-width": "131px"
					}
				}
			];
		}
	},
	methods: {
		async getUsuarios(params) {
			const data = {
				data: [],
				count: 0
			};

			try {
				// Se o path vier com o pk da empresa, quer dizer que esta dentro de uma empresa
				// Configuracao de coluna da tabela para quando acesso for por dentro de uma empresa
				if (this.empresaPk) {
					const {
						usuarios,
						totalUsuarios
					} = await Usuario.getUsuariosPorEmpresa(this.empresaPk, params);

					data.data = usuarios.map(usuario => {
						if (usuario.dataNascimento) {
							usuario.dataNascimento = DateHelper.convertDate(
								usuario.dataNascimento,
								null,
								"DD/MM/YYYY"
							)
						}

						return usuario;
					});
					data.count = totalUsuarios;
				} else {
					// Configuracao de coluna da tabela para quando acesso for por fora de uma empresa
					const { usuarios, totalUsuarios } = await Usuario.getUsuarios(
						params
					);

					data.data = usuarios.map(usuario => {
						if (usuario.dataNascimento) {
							usuario.dataNascimento = DateHelper.convertDate(
								usuario.dataNascimento,
								null,
								"DD/MM/YYYY"
							)
						}

						return usuario;
					});

					data.count = totalUsuarios;
				}

			} catch (error) {
				console.error(error);
			}

			return data;
		},
		verUsuario(data) {
			const ver = () => {
				this.usuarioEditarPk = data.pk;
				this.popupEditarUsuario = true;
			};

			return ver;
		},
		atualizarTabela() {
			this.atualizar = {
				table: !this.atualizar.table
			};
			this.usuarioEditarPk = null;
		},
		limparFiltrosTabela() {
			this.limparFiltros = {
				table: true
			};
		},
		...mapActions(["setBreadcrumb"])
	},
	created() {
		this.setBreadcrumb({
			title: "Gestão de usuários",
			list: [{ name: "Gestão de usuários", active: true }]
		});
	}
};
</script>
